import Swiper from "swiper/bundle";

const ReviewsByProductSlider = () => {
  const reviewsByProductSliders = [...document.querySelectorAll('.reviews-by-product__slider-wrapper')];

  const initializeSlider = () => {
    reviewsByProductSliders.forEach((reviewsByProductSlider) => {
      const sliderContainer = reviewsByProductSlider.querySelector('.reviews-by-product__slider');
      const slides = [...reviewsByProductSlider.querySelectorAll('.swiper-slide')];
      const controls = reviewsByProductSlider.querySelector(".swiper-controls");

      const minSlides = 2;

      const shouldInitializeSlider = slides.length >= minSlides;
      
      if (!shouldInitializeSlider) {
        if (controls) {
          controls.classList.add("d-none");
        }
      }

      if (shouldInitializeSlider) {
        if (controls) {
          controls.classList.remove("d-none");
        }

        const reviewsByProductCarousel = new Swiper(sliderContainer, { 
          slidesPerView: "auto",
          spaceBetween: 12,
          loop: true,
          scrollbar: {
            el: reviewsByProductSlider.querySelector('.swiper-scrollbar'),
          },
          navigation: {
            nextEl: reviewsByProductSlider.querySelector('.swiper__button-next'),
            prevEl: reviewsByProductSlider.querySelector('.swiper__button-prev'),
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            }
          }
        });
      }
    });
  };

  initializeSlider();

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      reviewsByProductSliders.forEach((reviewsByProductSlider) => {
        if (reviewsByProductSlider.swiper) {
          reviewsByProductSlider.swiper.destroy(true, true);
        }
      });
      initializeSlider();
    }, 200);
  });
};

export default ReviewsByProductSlider;
